/**
 * Csv Schema of Administrador
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {Administrador} from '@/model/resource/Administrador'

/* TODO: review generated schema */
export class CsvAdministradorSchema extends Schema {
  readonly name = 'CsvAdministrador'

  readonly fieldSet: FieldSet<Administrador> = {
    idAdministradorPk: schema => schema.model.idAdministradorPk,
    nome: schema => schema.model.nome,
    email: schema => schema.model.email,
    dataCriacao: schema => Helper.datetime(schema.model.dataCriacao),
  }
}
